import axiosClient from "../axios/axiosClient";

export function getOwnerships() {
  return axiosClient.get("/ownerships");
}

export function getOwnership(ownershipId) {
  return axiosClient.get(`/ownerships/${ownershipId}`);
}

export function createOwnership(data) {
  return axiosClient.post("/ownerships", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export const updateOwnership = (ownershipId, data) => {
  return axiosClient.put(`/ownerships/${ownershipId}`, data);
};

export function deleteOwnership(ownershipId) {
  return axiosClient.delete(`/ownerships/${ownershipId}`);
}
